import React from "react";
import { UIActionCreators } from "../../redux/action-creators";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { SVGIcon2 } from "../common/SVGIconV2";

function PanicTooltipCloseButton() {
  const dispatch = useDispatch();

  const closePanicTooltip = useCallback(
    data => dispatch(UIActionCreators.closePanicTooltip(data)),
    [dispatch]
  );

  const handleClick = async () => {
    closePanicTooltip(true);
  };

  return (
    <i onClick={handleClick}>
      <SVGIcon2 className="close" iconName="close" />
    </i>
  );
}

export default React.memo(PanicTooltipCloseButton);
